<template>
  <div>
    <!-- Time Actions -->
    <v-layout
      v-if="match.adminMode && match.displaySets && !match.isBlocked && match.timeControls.length > 0"
      :reverse="reverse"
      row
      no-wrap
    >
      <v-flex d-flex xs12>
        <v-card color="white" dark>
          <v-layout 
            py-2 
            px-2 
            align-center 
            justify-center 
            wrap>
            <slot name="match.timeControls">
              <v-btn
                v-for="(item,i) in match.timeControls"
                v-if="!item.disabled.l"
                :key="`tc_${i}`"
                :disabled="item.disabled.l"
                :color="item.color"
                class="btn-actions"
                outline
                small
                light
                @click="sendEvent(item, '')"
              >
                <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
              </v-btn>
            </slot>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Points Actions -->
    <template v-if="mode==='pro'">
      <!-- Team Actions -->
      <v-layout 
        v-if="match.adminMode && match.displaySets && !match.isBlocked" 
        row 
        no-wrap>
        <v-flex d-flex xs12>
          <v-card color="white" dark>
            <v-layout 
              :reverse="reverse" 
              py-2 
              px-2 
              align-center 
              justify-center 
              row 
              wrap>
              <v-flex xs6>
                <v-btn
                  outline
                  color="green"
                  small
                  light
                  round
                  @click.stop="dialogPlayerLocal = true"
                >{{ $t('page.match.players') }}</v-btn>
                <v-dialog v-model="dialogPlayerLocal" max-width="500px">
                  <v-card>
                    <v-card-title>{{ $t('page.match.playersLocalTeam') }}</v-card-title>
                    <v-card-text>
                      <v-btn
                        v-for="playerNum in match.maxPlayerNum"
                        :key="`na_${playerNum}`"
                        :outline="!match.setLocalPlayer.find(item => item.num === playerNum)"
                        :disabled="(match.setLocalPlayer.length >= match.numPlayerInSet + match.numExtraPlayerInSet) && !match.setLocalPlayer.find(item => item.num === playerNum)"
                        color="blue"
                        small
                        light
                        fab
                        @click="addPlayerNum('l', {num:playerNum})"
                      >{{ playerNum }}</v-btn>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="primary"
                        flat
                        @click.stop="dialogPlayerLocal=false"
                      >{{ $t('general.close') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
              <v-flex xs6>
                <v-btn
                  outline
                  color="green"
                  small
                  light
                  round
                  @click.stop="dialogPlayerVisitor = true"
                >{{ $t('page.match.players') }}</v-btn>
                <v-dialog v-model="dialogPlayerVisitor" max-width="500px">
                  <v-card>
                    <v-card-title>{{ $t('page.match.playersVisitorTeam') }}</v-card-title>
                    <v-card-text>
                      <v-btn
                        v-for="playerNum in match.maxPlayerNum"
                        :key="`na_${playerNum}`"
                        :outline="!match.setVisitorPlayer.find(item => item.num === playerNum)"
                        :disabled="(match.setVisitorPlayer.length >= match.numPlayerInSet + match.numExtraPlayerInSet) && !match.setVisitorPlayer.find(item => item.num === playerNum)"
                        color="blue"
                        small
                        light
                        fab
                        @click="addPlayerNum('v', {num:playerNum})"
                      >{{ playerNum }}</v-btn>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn
                        color="primary"
                        flat
                        @click.stop="dialogPlayerVisitor=false"
                      >{{ $t('general.close') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Player Actions -->
      <v-layout
        v-if="match.adminMode && match.displaySets && !match.isBlocked"
        :reverse="reverse"
        row
        wrap
      >
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              row 
              wrap>
              <slot name="numberActions">
                <v-flex class="btn-actions">
                  <v-btn
                    v-for="player in match.setLocalPlayer"
                    :key="`na_${player.num}`"
                    :outline="!action.player || action.player.num!==player.num || action.team!=='l'"
                    class="btn-actions"
                    color="blue"
                    small
                    light
                    fab
                    @click="setAction('player', player, 'l')"
                  >{{ player.num }}</v-btn>
                  <v-btn
                    v-for="item in extraPlayers"
                    :key="`l_e_${item}`"
                    :outline="!action.player || action.player.num!==item || action.team!=='l'"
                    class="btn-actions"
                    color="blue"
                    small
                    light
                    fab
                    @click="setAction('player', {num:item}, 'l')"
                  >{{ item }}</v-btn>
                </v-flex>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="numberActions">
                <v-flex>
                  <v-btn
                    v-for="player in match.setVisitorPlayer"
                    :key="`na_${player.num}`"
                    :outline="!action.player || action.player.num!==player.num || action.team!=='v'"
                    class="btn-actions"
                    color="blue"
                    small
                    light
                    fab
                    @click="setAction('player', player,'v')"
                  >{{ player.num }}</v-btn>
                  <v-btn
                    v-for="item in extraPlayers"
                    :key="`v_e_${item}`"
                    :outline="!action.player || action.player.num!==item || action.team!=='v'"
                    class="btn-actions"
                    color="blue"
                    small
                    light
                    fab
                    @click="setAction('player', {num:item},'v')"
                  >{{ item }}</v-btn>
                </v-flex>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Points Actions -->
      <v-layout
        v-if="match.adminMode && match.displaySets && !match.isBlocked"
        :reverse="reverse"
        row
        no-wrap
      >
        <v-flex d-flex xs12>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="localActions">
                <v-btn
                  v-for="(item,i) in modePointControls"
                  v-if="!item.controlHide"
                  :key="`la_${i}`"
                  :disabled="action.player===null"
                  :color="item.color"
                  :outline="!action.control || action.control.code!==item.code"
                  class="btn-actions"
                  small
                  light
                  fab
                  @click="setAction('action', item)"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="localOtherActions">
                <v-btn
                  v-for="(item,i) in match.actionControls"
                  v-if="!item.controlHide"
                  :key="`loa_${i}`"
                  :disabled="action.player===null"
                  :color="item.color"
                  :outline="!action.control || action.control.code!==item.code"
                  class="btn-actions"
                  small
                  light
                  fab
                  @click="setAction('action', item)"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog 
        v-model="dialogChange" 
        :persistent="true" 
        max-width="500px">
        <v-card>
          <v-card-title>{{ $t('page.match.playersLocalTeam') }}</v-card-title>
          <v-card-text>
            <v-btn
              v-for="playerNum in changePlayers"
              :key="`change_${playerNum}`"
              outline
              color="blue"
              small
              light
              fab
              @click="changePlayer({num:playerNum})"
            >{{ playerNum }}</v-btn>
          </v-card-text>
          <v-card-actions>
            <v-btn 
              color="primary" 
              flat 
              @click.stop="dialogChange=false">{{ $t('general.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-else>
      <!-- Points Actions -->
      <v-layout
        v-if="match.adminMode && match.displaySets && !match.isBlocked"
        :reverse="reverse"
        row
        no-wrap
      >
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="localActions">
                <v-btn
                  v-for="(item,i) in modePointControls"
                  v-if="!item.controlHide"
                  :key="`la_${i}`"
                  :disabled="item.disabled.l"
                  :color="item.color"
                  class="btn-actions"
                  outline
                  small
                  light
                  fab
                  @click="sendEvent(item, 'l')"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="visitorActions">
                <v-btn
                  v-for="(item,i) in modePointControls"
                  v-if="!item.controlHide"
                  :key="`va_${i}`"
                  :disabled="item.disabled.v"
                  :color="item.color"
                  class="btn-actions"
                  outline
                  small
                  light
                  fab
                  @click="sendEvent(item, 'v')"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
      <!-- Other Actions -->
      <v-layout
        v-if="match.adminMode && match.displaySets && !match.isBlocked"
        :reverse="reverse"
        row
        no-wrap
      >
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="localOtherActions">
                <v-btn
                  v-for="(item,i) in mode==='basic' && match.actionBasicControls.length > 0 ? match.actionBasicControls: match.actionControls"
                  v-if="!item.controlHide"
                  :key="`loa_${i}`"
                  :disabled="item.disabled.l"
                  :color="item.color"
                  class="btn-actions"
                  outline
                  small
                  light
                  fab
                  @click="sendEvent(item, 'l')"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex d-flex xs6>
          <v-card color="white" dark>
            <v-layout 
              py-2 
              px-2 
              align-center 
              justify-center 
              wrap>
              <slot name="visitorOtherActions">
                <v-btn
                  v-for="(item,i) in mode==='basic' && match.actionBasicControls.length > 0 ? match.actionBasicControls: match.actionControls"
                  v-if="!item.controlHide"
                  :key="`voa_${i}`"
                  :disabled="item.disabled.v"
                  :color="item.color"
                  class="btn-actions"
                  outline
                  small
                  light
                  fab
                  @click="sendEvent(item, 'v')"
                >
                  <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
                  {{ $t(`sport.controls.${item.code}.short`) }}
                </v-btn>
              </slot>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <!-- Remove Actions -->
    <v-layout 
      v-if="match.adminMode && match.displaySets && !match.isBlocked" 
      row 
      no-wrap>
      <v-flex d-flex xs12>
        <v-card color="white" dark>
          <v-layout 
            py-2 
            px-2 
            align-center 
            justify-center 
            wrap>
            <slot name="globalActions">
              <v-btn
                v-for="item in modes"
                :key="`m_${item}`"
                :disabled="mode===item"
                color="purple"
                outline
                small
                light
                @click="toogleMode(item)"
              >{{ item }}</v-btn>
              <v-spacer/>
              <v-btn
                v-for="(item,i) in match.globalControls"
                :key="`g_${i}`"
                :disabled="item.disabled"
                :color="item.color"
                class="btn-actions"
                outline
                small
                light
                fab
                @click="sendEvent(item, '')"
              >
                <v-icon v-if="item.icon" small>{{ item.icon }}</v-icon>
              </v-btn>
            </slot>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
// const debug = require('debug')('OD::BoardPanel')

export default {
  name: 'BoardPanel',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
    mode: {
      type: String,
      required: true,
    },
    modePointControls: {
      type: Array,
      required: true,
    },
    modes: {
      type: Array,
      required: true,
    },
    extraPlayers: {
      type: Array,
      required: true,
    },
    action: {
      type: Object,
      required: true,
    },
    dialogChange: {
      type: Boolean,
      default: false,
    },
    changePlayers: {
      type: Array,
      default: null,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogPlayerLocal: false,
      dialogPlayerVisitor: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {
    toogleMode(mode) {
      this.$emit('toogleMode', mode)
    },
    addPlayerNum(team, player) {
      this.$emit('onAddPlayer', {
        team,
        player,
      })
    },
    setAction(action, data, team) {
      this.$emit('onSetAction', {
        action,
        data,
        team,
      })
    },
    sendEvent(data, team) {
      this.$emit('onSendEvent', {
        data,
        team,
      })
    },
    changePlayer(player) {
      this.$emit('onChangePlayer', {
        player,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-actions {
  margin: 1px;
  border-radius: 10px;
}
</style>
